import React from 'react'
import { observer } from 'mobx-react-lite'

export default observer(function EditLocationCommentOptions({ isOpen, onEdit, onDelete, onClose }) {

  return (
    isOpen && (
      <div
        className="flex flex-col items-start absolute top-7 right-7 bg-rb-dark-mode-lighter p-2 rounded-xl z-30"
      >
        <button
          className='text-rb-lighter-grey'
          onClick={() => {
            onEdit()
            onClose()
          }}
        >
          Edit...
        </button>
        <button
          className='text-rb-lighter-grey'
          onClick={() => {
            onDelete()
            onClose()
            }}>
          Delete Comment
        </button>
      </div>
    )
  )
})
